
import { createElement } from "react";
import React from "react";
import { reactElement, reactApi } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { useTranslation } from "react-i18next";
import { Permissions_has, Permission, Permissions_allowsReceiverType } from "../../Shared/Roles.js";
import { canCreateStocktakings, usePermissions } from "../../UserPermissions.js";
import { Exception, equals, createObj } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { concat, join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { empty, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { ArchiveDialog } from "./Dialog/ArchiveDialog.js";
import { Msg } from "../Types.js";
import { Feature, isFeatureEnabled } from "../../FeatureFlip.js";
import { TextButton } from "../../Components/Button.js";
import Visible from "../../../public/assets/icons/Visible.svg";
import Invisible_1 from "../../../public/assets/icons/Invisible_1.svg";
import Download_File from "../../../public/assets/icons/Download_File.svg";
import Printer from "../../../public/assets/icons/Printer.svg";
import { filter, tryFind, map, singleton as singleton_1, isEmpty, choose, ofArray } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Requests_VehicleDto_$reflection, Requests_StudentDto_$reflection, Requests_SchoolClassDto_$reflection, Requests_ConstructionSiteDto_$reflection, Requests_ProjectDto_$reflection, Requests_SubcontractorDto_$reflection, Requests_RoomDto_$reflection, Requests_ExternalPersonDto_$reflection, Requests_EmployeeDto_$reflection, Requests_UserDto_$reflection, ReceiverTypeName } from "../../Shared/User.js";
import Followers from "../../../public/assets/icons/Followers.svg";
import Following from "../../../public/assets/icons/Following.svg";
import Shipment_Check from "../../../public/assets/icons/Shipment_Check.svg";
import { RouterModule_encodeQueryString, RouterModule_nav } from "../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { DispolistAssignView } from "../../InventoryLists/View.js";
import { UnassignDispolistDialog } from "./Dialog/UnassignDispolistDialog.js";
import { ReceiverLastStocktaking, canReadStocktakingHistory } from "../../Widgets/StocktakingHistory.js";
import { useFeliz_React__React_useDeferred_Static_Z241A641 } from "../../fable_modules/Feliz.UseDeferred.2.0.0/UseDeferred.fs.js";
import { ImageWidget } from "../../Widgets/Image/ImageWidget.js";
import { defaultOf } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { ChangePasswordDialog } from "../../Receiver/ChangePasswordDialog.js";
import { ChangeUserEmailOrPhoneNumberDialog } from "../../Receiver/ChangeEmailOrPhoneNumberDialog.js";
import { ConvertUserToEmployeeDialog } from "../../Receiver/TransformUserToEmployeeDialog.js";
import Pencil from "../../../public/assets/icons/Pencil.svg";
import { ChangeUserWithoutLoginToUserWithLoginDialog } from "../../Receiver/TransformUserWithoutLoginToUserWithLoginDialog.js";
import { map as map_1, defaultArg } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { parse } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Guid.js";
import { Role__ToI18nString, UserId as UserId_3, PropertyConfigurationId } from "../../Shared/Shared.js";
import { Async_getAssignedRole } from "../../Requests/Roles.js";
import { Async_valueOrRaise } from "../../Requests/Receivers.js";
import { addPrefix, Async_fetchWithDecoder } from "../../CommunicationV2.js";
import { unwrapUserId } from "../../Shared/Helper.js";
import { HttpMethod } from "../../fable_modules/Fable.SimpleHttp.3.6.0/Types.fs.js";
import { singleton as singleton_2 } from "../../fable_modules/fable-library-js.5.0.0-rc.2/AsyncBuilder.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { PropertyList } from "../../Widgets/PropertyListWidget.js";
import { roleDisplayName } from "../../Common.js";
import { CustomPropertiesPropertyList } from "../../Widgets/CustomPropertiesPropertyList.js";

export function ReceiverDetailButtons(props) {
    let elems;
    const patternInput = reactApi.useState(false);
    const setIsArchivedDialogOpen = patternInput[1];
    const t = useTranslation()[0];
    const canArchiveReceiver = Permissions_allowsReceiverType(usePermissions(), new Permission(45, []), props.ReceiverType);
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "gap-4", "print:hidden"])], (elems = toList(delay(() => append(singleton(createElement(ArchiveDialog, {
        IsArchived: props.IsArchived,
        IsOpen: patternInput[0],
        OnClose: () => {
            setIsArchivedDialogOpen(false);
        },
        OnSave: () => {
            props.Dispatch(new Msg(25, [!props.IsArchived]));
        },
    })), delay(() => {
        let Label;
        return append((isFeatureEnabled(new Feature(6, [])) && canArchiveReceiver) ? singleton(createElement(TextButton, (Label = (props.IsArchived ? t("user.retrive_from_archive") : t("user.archive")), {
            ComponentState: "enabled",
            Icon: props.IsArchived ? Visible() : Invisible_1(),
            Label: Label,
            OnClick: () => {
                setIsArchivedDialogOpen(true);
            },
            TestId: "toolbox-receiver-detail-view-archived-archive-button",
            Variant: "default",
        }))) : empty(), delay(() => {
            let Label_1;
            return append(((props.HasInspectionDocuments && props.AccountSettings.InspectionsEnabled) && isFeatureEnabled(new Feature(21, []))) ? singleton(createElement(TextButton, (Label_1 = t("toolbox.download_inspection_documents"), {
                ComponentState: "enabled",
                Icon: Download_File(),
                Label: Label_1,
                OnClick: () => {
                    props.Dispatch(new Msg(12, []));
                },
                TestId: "download-inspection-documents-zip-button",
                Variant: "default",
            }))) : empty(), delay(() => singleton(createElement(TextButton, {
                ComponentState: "enabled",
                Icon: Printer(),
                Label: "",
                OnClick: () => {
                    window.print();
                },
                TestId: "receiver-print-button",
                Variant: "default",
            }))));
        }));
    })))), ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function ToolboxDetailActions(props) {
    let elems_1;
    const t = useTranslation()[0];
    const permissions = usePermissions();
    const canAssignDispolist = Permissions_has(permissions, new Permission(6, [])) && Permissions_has(permissions, new Permission(98, []));
    const canReturnDispolist = Permissions_has(permissions, new Permission(7, []));
    const canCreateStocktaking = ((isFeatureEnabled(new Feature(4, [])) && canCreateStocktakings(permissions)) && !equals(props.Receiver.ReceiverType, new ReceiverTypeName(10, []))) && !props.Receiver.IsArchived;
    const patternInput_1 = reactApi.useState(false);
    const setIsModalOpen = patternInput_1[1];
    const dispolistHistoryRows = choose((row) => {
        const matchValue = row.ToolHistoryElementType;
        switch (matchValue.tag) {
            case 0:
            case 3:
            case 1:
                return undefined;
            default:
                return [row.InventoryName, row.ToolId, row.EventDate];
        }
    }, props.HistoryRows);
    const patternInput_2 = reactApi.useState(false);
    const setIsUnassignDispolistDialogOpen = patternInput_2[1];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "gap-7", "mb-16", "justify-between"])], (elems_1 = toList(delay(() => {
        let elems;
        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "gap-3", "print:hidden"])], (elems = toList(delay(() => {
            let Label;
            return append(((isFeatureEnabled(new Feature(0, [])) && !equals(props.Receiver.ReceiverType, new ReceiverTypeName(10, []))) && !props.Receiver.IsArchived) ? append(canAssignDispolist ? singleton(createElement(TextButton, (Label = t("dispolist_assign.assign_dispolist"), {
                ComponentState: "enabled",
                Icon: Followers(),
                Label: Label,
                OnClick: () => {
                    setIsModalOpen(true);
                },
                TestId: "assign-dispolist-button",
                Variant: "default",
            }))) : empty(), delay(() => {
                let Label_1;
                return (canReturnDispolist && !isEmpty(dispolistHistoryRows)) ? singleton(createElement(TextButton, (Label_1 = t("toolbox.dispolist_return"), {
                    ComponentState: "enabled",
                    Icon: Following(),
                    Label: Label_1,
                    OnClick: () => {
                        setIsUnassignDispolistDialogOpen(true);
                    },
                    TestId: "dispolist-return-button",
                    Variant: "default",
                }))) : empty();
            })) : empty(), delay(() => {
                let Label_2;
                return canCreateStocktaking ? singleton(createElement(TextButton, (Label_2 = t("stocktaking.create_stocktaking_for_receiver"), {
                    ComponentState: "enabled",
                    Icon: Shipment_Check(),
                    Label: Label_2,
                    OnClick: () => {
                        RouterModule_nav(ofArray(["stocktaking", "new" + RouterModule_encodeQueryString(singleton_1(["receiver", props.Receiver.Id]))]), 1, 1);
                    },
                    TestId: "receiver-create-stocktaking-button",
                    Variant: "default",
                }))) : empty();
            }));
        })), ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => append(canAssignDispolist ? singleton(createElement(DispolistAssignView, {
            Customer: props.Customer,
            IsOpen: patternInput_1[0],
            OnClose: () => {
                setIsModalOpen(false);
            },
            Receiver: props.Toolbox.Receiver,
            SuccessCallback: () => {
                props.Dispatch(new Msg(27, []));
            },
        })) : empty(), delay(() => append(singleton(createElement(UnassignDispolistDialog, {
            DispolistIdsAndNames: dispolistHistoryRows,
            IsOpen: patternInput_2[0],
            OnClose: () => {
                setIsUnassignDispolistDialogOpen(false);
            },
            SenderId: props.Toolbox.Receiver.Id,
            SuccessCallback: () => {
                props.Dispatch(new Msg(27, []));
            },
            UserData: props.UserData,
        })), delay(() => singleton(props.Actions)))))));
    })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

export function ReceiverDetails(props) {
    let elems_4, elems_3, elems, elems_2;
    const permissions = usePermissions();
    const canUpdateReceiver = Permissions_allowsReceiverType(permissions, new Permission(43, []), props.ReceiverType);
    const canReadStocktakings = canReadStocktakingHistory(permissions, props.AccountSettings);
    const data = useFeliz_React__React_useDeferred_Static_Z241A641(props.FetchReceiver, [props.TriggerRequest]);
    switch (data.tag) {
        case 2: {
            const receiver = data.fields[0];
            return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "grow"])], (elems_4 = [props.ReceiverActions(receiver), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-wrap", "gap-x-10", "gap-y-6", "grow"])], (elems_3 = [reactElement("div", createObj(ofArray([["className", join(" ", ["print:hidden", "max-w-full"])], (elems = [createElement(ImageWidget, {
                CanEditImage: canUpdateReceiver,
                FormState: props.FormState,
                ImageUrl: props.ImageUrl(receiver),
                OnDeleteImage: props.OnDeleteImage,
                OnUploadImage: props.OnUploadImage,
            })], ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["min-w-0"])], (elems_2 = toList(delay(() => append(singleton(props.ReceiverDetails(receiver)), delay(() => {
                let elems_1;
                return canReadStocktakings ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mt-6"])], (elems_1 = [createElement(ReceiverLastStocktaking, {
                    ReceiverId: props.ReceiverId,
                })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))) : empty();
            })))), ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
        }
        default:
            return defaultOf();
    }
}

function UserDetailButtons(props) {
    let elems;
    const t = useTranslation()[0];
    const permissions = usePermissions();
    const canManageCredentials = Permissions_has(permissions, new Permission(56, []));
    const canUpdateUser = Permissions_has(permissions, new Permission(54, []));
    const canArchiveUser = Permissions_allowsReceiverType(permissions, new Permission(45, []), new ReceiverTypeName(0, []));
    const patternInput_1 = reactApi.useState(false);
    const setIsChangePasswordDialogOpen = patternInput_1[1];
    const patternInput_2 = reactApi.useState(false);
    const setIsChangeEmailOrPhoneNumerDialogOpen = patternInput_2[1];
    const patternInput_3 = reactApi.useState(false);
    const setIsArchivedDialogOpen = patternInput_3[1];
    const patternInput_4 = reactApi.useState(false);
    const setIsConvertToEmployeeDialogOpen = patternInput_4[1];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "gap-4", "print:hidden"])], (elems = toList(delay(() => append(singleton(createElement(ChangePasswordDialog, {
        IsOpen: patternInput_1[0],
        OnClose: () => {
            setIsChangePasswordDialogOpen(false);
        },
        SuccessCallback: () => {
            props.Dispatch(new Msg(27, []));
        },
        UserId: props.User.Id,
    })), delay(() => append(singleton(createElement(ChangeUserEmailOrPhoneNumberDialog, {
        CurrentLoginInformation: props.User.LoginInformation,
        IsOpen: patternInput_2[0],
        OnClose: () => {
            setIsChangeEmailOrPhoneNumerDialogOpen(false);
        },
        SuccessCallback: () => {
            props.Dispatch(new Msg(27, []));
            props.Dispatch(new Msg(15, []));
        },
        UserId: props.User.Id,
    })), delay(() => append(singleton(createElement(ArchiveDialog, {
        IsArchived: props.Receiver.IsArchived,
        IsOpen: patternInput_3[0],
        OnClose: () => {
            setIsArchivedDialogOpen(false);
        },
        OnSave: () => {
            props.Dispatch(new Msg(25, [!props.Receiver.IsArchived]));
        },
    })), delay(() => append(singleton(createElement(ConvertUserToEmployeeDialog, {
        IsOpen: patternInput_4[0],
        OnClose: () => {
            setIsConvertToEmployeeDialogOpen(false);
        },
        SuccessCallback: (employeeId) => {
            props.Dispatch(new Msg(24, [employeeId]));
        },
        UserId: props.User.Id,
    })), delay(() => {
        let Label;
        return append(((canManageCredentials && !props.Receiver.IsArchived) && !props.User.SSOEnabled) ? append((props.User.LoginInformation.tag === 0) ? singleton(createElement(TextButton, (Label = t("user.change_password_dialog.title"), {
            ComponentState: "enabled",
            Icon: Pencil(),
            Label: Label,
            OnClick: () => {
                setIsChangePasswordDialogOpen(true);
            },
            TestId: "change-password-button",
            Variant: "default",
        }))) : (empty()), delay(() => {
            let Label_1;
            return singleton(createElement(TextButton, (Label_1 = ((props.User.LoginInformation.tag === 0) ? t("user.change_email") : t("user.change_phone_number")), {
                ComponentState: "enabled",
                Icon: Pencil(),
                Label: Label_1,
                OnClick: () => {
                    setIsChangeEmailOrPhoneNumerDialogOpen(true);
                },
                TestId: "change-email-or-phone-number-button",
                Variant: "default",
            })));
        })) : empty(), delay(() => {
            let Label_2;
            return append(((canUpdateUser && !props.Receiver.IsArchived) && !props.User.SSOEnabled) ? singleton(createElement(TextButton, (Label_2 = t("user.convert_to_employee"), {
                ComponentState: "enabled",
                Icon: Pencil(),
                Label: Label_2,
                OnClick: () => {
                    setIsConvertToEmployeeDialogOpen(true);
                },
                TestId: "convert-to-employee-button",
                Variant: "default",
            }))) : empty(), delay(() => {
                let Label_3;
                return append((isFeatureEnabled(new Feature(6, [])) && canArchiveUser) ? singleton(createElement(TextButton, (Label_3 = (props.Receiver.IsArchived ? t("user.retrive_from_archive") : t("user.archive")), {
                    ComponentState: "enabled",
                    Icon: props.Receiver.IsArchived ? Visible() : Invisible_1(),
                    Label: Label_3,
                    OnClick: () => {
                        setIsArchivedDialogOpen(true);
                    },
                    TestId: "toolbox-receiver-detail-view-archived-archive-button",
                    Variant: "default",
                }))) : empty(), delay(() => {
                    let Label_4;
                    return append(((props.HasInspectionDocuments && props.AccountSettings.InspectionsEnabled) && isFeatureEnabled(new Feature(21, []))) ? singleton(createElement(TextButton, (Label_4 = t("toolbox.download_inspection_documents"), {
                        ComponentState: "enabled",
                        Icon: Download_File(),
                        Label: Label_4,
                        OnClick: () => {
                            props.Dispatch(new Msg(12, []));
                        },
                        TestId: "download-inspection-documents-zip-button",
                        Variant: "default",
                    }))) : empty(), delay(() => singleton(createElement(TextButton, {
                        ComponentState: "enabled",
                        Icon: Printer(),
                        Label: "",
                        OnClick: () => {
                            window.print();
                        },
                        TestId: "receiver-print-button",
                        Variant: "default",
                    }))));
                }));
            }));
        }));
    })))))))))), ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function EmployeeDetailButtons(props) {
    let elems;
    const patternInput = useTranslation();
    const canCreateUser = Permissions_has(usePermissions(), new Permission(53, []));
    const patternInput_1 = reactApi.useState(false);
    const setIsTransformEmployeeToUserDialogOpen = patternInput_1[1];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "gap-4"])], (elems = toList(delay(() => append(singleton(createElement(ChangeUserWithoutLoginToUserWithLoginDialog, {
        Employee: props.Employee,
        IsOpen: patternInput_1[0],
        OnClose: () => {
            setIsTransformEmployeeToUserDialogOpen(false);
        },
        SuccessCallback: (userId) => {
            props.Dispatch(new Msg(24, [userId]));
        },
    })), delay(() => {
        let Label;
        return append((canCreateUser && !props.Receiver.IsArchived) ? singleton(createElement(TextButton, (Label = patternInput[0]("user.change_user_type"), {
            ComponentState: "enabled",
            Icon: Pencil(),
            Label: Label,
            OnClick: () => {
                setIsTransformEmployeeToUserDialogOpen(true);
            },
            TestId: "change-user-type-button",
            Variant: "default",
        }))) : empty(), delay(() => singleton(createElement(ReceiverDetailButtons, {
            AccountSettings: props.AccountSettings,
            CustomerConfiguration: props.CustomerConfiguration,
            Dispatch: props.Dispatch,
            HasInspectionDocuments: props.HasInspectionDocuments,
            IsArchived: props.Receiver.IsArchived,
            ReceiverType: props.Receiver.ReceiverType,
            UserData: props.UserData,
        }))));
    })))), ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function customPropertiesFields(propertyConfigurations, customProperties, propertyConfigurationType) {
    return map((propertyConfiguration_1) => ({
        Label: propertyConfiguration_1.Name,
        Value: defaultArg(map_1((customProperty_1) => customProperty_1.Value, tryFind((customProperty) => equals(new PropertyConfigurationId(parse(customProperty.Id)), propertyConfiguration_1.Id), customProperties)), ""),
    }), filter((propertyConfiguration) => equals(propertyConfiguration.Visibility, propertyConfigurationType), propertyConfigurations));
}

export function UserDetails(props) {
    const t = useTranslation()[0];
    const assignedRole = useFeliz_React__React_useDeferred_Static_Z241A641(Async_getAssignedRole(props.ReceiverId), [props.ReceiverId, props.TriggerRerender]);
    return createElement(ReceiverDetails, {
        AccountSettings: props.AccountSettings,
        FetchReceiver: Async_valueOrRaise(Async_fetchWithDecoder(addPrefix(concat("/api/receivers/users/", unwrapUserId(new UserId_3(props.ReceiverId)), ..."/details")), "", new HttpMethod(0, []), "application/json", (response) => singleton_2.Delay(() => {
            let resp;
            const matchValue = response.content;
            switch (matchValue.tag) {
                case 0: {
                    throw new Exception("not implemented - text response");
                    break;
                }
                case 1: {
                    throw new Exception("not implemented - blob response");
                    break;
                }
                case 3: {
                    resp = matchValue.fields[0];
                    break;
                }
                default:
                    resp = (new Uint8Array(matchValue.fields[0]));
            }
            return singleton_2.Return(Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(resp), Requests_UserDto_$reflection()));
        }))),
        FormState: props.FormState,
        ImageUrl: (user_1) => user_1.ImageUrl,
        OnDeleteImage: props.OnDeleteImage,
        OnUploadImage: props.OnUploadImage,
        ReceiverActions: (user_2) => createElement(ToolboxDetailActions, {
            Actions: createElement(UserDetailButtons, {
                AccountSettings: props.AccountSettings,
                Dispatch: props.Dispatch,
                HasInspectionDocuments: props.ToolBox.HasInspectionDocuments,
                Receiver: props.ToolBox.Receiver,
                User: user_2,
            }),
            Customer: props.Customer,
            Dispatch: props.Dispatch,
            HistoryRows: props.HistoryRows,
            Receiver: props.ToolBox.Receiver,
            Toolbox: props.ToolBox,
            UserData: props.UserData,
        }),
        ReceiverDetails: (user_3) => {
            let elems_1, elems;
            return reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems_1 = [createElement(PropertyList, {
                Properties: toList(delay(() => append(singleton({
                    Label: t("general.name"),
                    TestId: "receiver-name",
                    Value: user_3.Name,
                }), delay(() => append(singleton({
                    Label: t("user.personnel_number"),
                    TestId: "receiver-personnel-number",
                    Value: user_3.PersonnelNumber,
                }), delay(() => append(isFeatureEnabled(new Feature(17, [])) ? (props.AccountSettings.BusinessUnitsEnabled ? singleton({
                    Label: t("business_units.business_unit"),
                    TestId: "receiver-business-unit-name",
                    Value: defaultArg(user_3.BusinessUnitNames, ""),
                }) : empty()) : empty(), delay(() => append(singleton({
                    Label: t("user.department"),
                    TestId: "receiver-department",
                    Value: user_3.Department,
                }), delay(() => append(singleton({
                    Label: t("general.location"),
                    TestId: "receiver-location",
                    Value: defaultArg(map_1((_arg) => _arg.Name, tryFind((location) => equals(location.Id, user_3.LocationId), props.Locations)), ""),
                }), delay(() => append(isFeatureEnabled(new Feature(6, [])) ? singleton({
                    Label: t("user.is_archived"),
                    TestId: "receiver-is-archived",
                    Value: user_3.IsArchived ? t("general.yes") : t("general.no"),
                }) : empty(), delay(() => {
                    let matchValue_1;
                    return append((matchValue_1 = user_3.LoginInformation, (matchValue_1.tag === 1) ? singleton({
                        Label: t("user.phone_number"),
                        TestId: "receiver-phone-number",
                        Value: matchValue_1.fields[0],
                    }) : singleton({
                        Label: t("general.email"),
                        TestId: "receiver-email",
                        Value: matchValue_1.fields[0],
                    })), delay(() => {
                        let role;
                        return singleton({
                            Label: t("general.role"),
                            TestId: "receiver-role",
                            Value: (assignedRole.tag === 3) ? t(Role__ToI18nString(user_3.Role)) : ((assignedRole.tag === 1) ? t(Role__ToI18nString(user_3.Role)) : ((assignedRole.tag === 0) ? t(Role__ToI18nString(user_3.Role)) : ((assignedRole.fields[0] == null) ? t(Role__ToI18nString(user_3.Role)) : ((role = assignedRole.fields[0], roleDisplayName(t, role)))))),
                        });
                    }));
                })))))))))))))),
            }), reactElement("div", createObj(ofArray([["className", join(" ", ["border-t", "border-divider"])], (elems = [createElement(CustomPropertiesPropertyList, {
                Currency: props.CustomerConfiguration.Currency,
                CustomProperties: user_3.CustomProperties,
            })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
        },
        ReceiverId: props.ReceiverId,
        ReceiverType: props.ToolBox.Receiver.ReceiverType,
        TriggerRequest: props.TriggerRerender,
        UserData: props.UserData,
    });
}

export function EmployeeDetails(props) {
    const t = useTranslation()[0];
    return createElement(ReceiverDetails, {
        AccountSettings: props.AccountSettings,
        FetchReceiver: Async_valueOrRaise(Async_fetchWithDecoder(addPrefix(concat("/api/receivers/employees/", unwrapUserId(new UserId_3(props.ReceiverId)), ..."/details")), "", new HttpMethod(0, []), "application/json", (response) => singleton_2.Delay(() => {
            let resp;
            const matchValue = response.content;
            switch (matchValue.tag) {
                case 0: {
                    throw new Exception("not implemented - text response");
                    break;
                }
                case 1: {
                    throw new Exception("not implemented - blob response");
                    break;
                }
                case 3: {
                    resp = matchValue.fields[0];
                    break;
                }
                default:
                    resp = (new Uint8Array(matchValue.fields[0]));
            }
            return singleton_2.Return(Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(resp), Requests_EmployeeDto_$reflection()));
        }))),
        FormState: props.FormState,
        ImageUrl: (employee) => employee.ImageUrl,
        OnDeleteImage: props.OnDeleteImage,
        OnUploadImage: props.OnUploadImage,
        ReceiverActions: (employee_1) => createElement(ToolboxDetailActions, {
            Actions: createElement(EmployeeDetailButtons, {
                AccountSettings: props.AccountSettings,
                CustomerConfiguration: props.CustomerConfiguration,
                Dispatch: props.Dispatch,
                Employee: employee_1,
                HasInspectionDocuments: props.ToolBox.HasInspectionDocuments,
                Receiver: props.ToolBox.Receiver,
                UserData: props.UserData,
            }),
            Customer: props.Customer,
            Dispatch: props.Dispatch,
            HistoryRows: props.HistoryRows,
            Receiver: props.ToolBox.Receiver,
            Toolbox: props.ToolBox,
            UserData: props.UserData,
        }),
        ReceiverDetails: (employee_2) => {
            let elems_1, elems;
            return reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems_1 = [createElement(PropertyList, {
                Properties: toList(delay(() => append(singleton({
                    Label: t("general.name"),
                    TestId: "receiver-name",
                    Value: employee_2.Name,
                }), delay(() => append(isFeatureEnabled(new Feature(17, [])) ? (props.AccountSettings.BusinessUnitsEnabled ? singleton({
                    Label: t("business_units.business_unit"),
                    TestId: "receiver-business-unit-name",
                    Value: defaultArg(employee_2.BusinessUnitName, ""),
                }) : empty()) : empty(), delay(() => append(isFeatureEnabled(new Feature(6, [])) ? singleton({
                    Label: t("user.is_archived"),
                    TestId: "receiver-is-archived",
                    Value: employee_2.IsArchived ? t("general.yes") : t("general.no"),
                }) : empty(), delay(() => append(isFeatureEnabled(new Feature(15, [])) ? singleton({
                    Label: t("general.email"),
                    TestId: "receiver-email",
                    Value: employee_2.Email,
                }) : empty(), delay(() => append(singleton({
                    Label: t("user.personnel_number"),
                    TestId: "receiver-personnel-number",
                    Value: employee_2.PersonnelNumber,
                }), delay(() => append(singleton({
                    Label: t("user.department"),
                    TestId: "receiver-department",
                    Value: employee_2.Department,
                }), delay(() => singleton({
                    Label: t("general.location"),
                    TestId: "receiver-location",
                    Value: defaultArg(map_1((_arg) => _arg.Name, tryFind((location) => equals(location.Id, employee_2.LocationId), props.Locations)), ""),
                }))))))))))))))),
            }), reactElement("div", createObj(ofArray([["className", join(" ", ["border-t", "border-divider"])], (elems = [createElement(CustomPropertiesPropertyList, {
                Currency: props.CustomerConfiguration.Currency,
                CustomProperties: employee_2.CustomProperties,
            })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
        },
        ReceiverId: props.ReceiverId,
        ReceiverType: props.ToolBox.Receiver.ReceiverType,
        TriggerRequest: props.TriggerRerender,
        UserData: props.UserData,
    });
}

export function ExternalPersonDetails(props) {
    const t = useTranslation()[0];
    return createElement(ReceiverDetails, {
        AccountSettings: props.AccountSettings,
        FetchReceiver: Async_valueOrRaise(Async_fetchWithDecoder(addPrefix(concat("/api/receivers/external-persons/", unwrapUserId(new UserId_3(props.ReceiverId)), ..."/details")), "", new HttpMethod(0, []), "application/json", (response) => singleton_2.Delay(() => {
            let resp;
            const matchValue = response.content;
            switch (matchValue.tag) {
                case 0: {
                    throw new Exception("not implemented - text response");
                    break;
                }
                case 1: {
                    throw new Exception("not implemented - blob response");
                    break;
                }
                case 3: {
                    resp = matchValue.fields[0];
                    break;
                }
                default:
                    resp = (new Uint8Array(matchValue.fields[0]));
            }
            return singleton_2.Return(Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(resp), Requests_ExternalPersonDto_$reflection()));
        }))),
        FormState: props.FormState,
        ImageUrl: (externalPerson) => externalPerson.ImageUrl,
        OnDeleteImage: props.OnDeleteImage,
        OnUploadImage: props.OnUploadImage,
        ReceiverActions: (_arg) => createElement(ToolboxDetailActions, {
            Actions: createElement(ReceiverDetailButtons, {
                AccountSettings: props.AccountSettings,
                CustomerConfiguration: props.CustomerConfiguration,
                Dispatch: props.Dispatch,
                HasInspectionDocuments: props.ToolBox.HasInspectionDocuments,
                IsArchived: props.ToolBox.Receiver.IsArchived,
                ReceiverType: props.ToolBox.Receiver.ReceiverType,
                UserData: props.UserData,
            }),
            Customer: props.Customer,
            Dispatch: props.Dispatch,
            HistoryRows: props.HistoryRows,
            Receiver: props.ToolBox.Receiver,
            Toolbox: props.ToolBox,
            UserData: props.UserData,
        }),
        ReceiverDetails: (externalPerson_1) => {
            let elems_1, elems;
            return reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems_1 = [createElement(PropertyList, {
                Properties: toList(delay(() => append(singleton({
                    Label: t("general.name"),
                    TestId: "receiver-name",
                    Value: externalPerson_1.Name,
                }), delay(() => append(isFeatureEnabled(new Feature(17, [])) ? (props.AccountSettings.BusinessUnitsEnabled ? singleton({
                    Label: t("business_units.business_unit"),
                    TestId: "receiver-business-unit-name",
                    Value: defaultArg(externalPerson_1.BusinessUnitName, ""),
                }) : empty()) : empty(), delay(() => append(isFeatureEnabled(new Feature(15, [])) ? singleton({
                    Label: t("general.email"),
                    TestId: "receiver-email",
                    Value: externalPerson_1.Email,
                }) : empty(), delay(() => (isFeatureEnabled(new Feature(6, [])) ? singleton({
                    Label: t("user.is_archived"),
                    TestId: "receiver-is-archived",
                    Value: externalPerson_1.IsArchived ? t("general.yes") : t("general.no"),
                }) : empty()))))))))),
            }), reactElement("div", createObj(ofArray([["className", join(" ", ["border-t", "border-divider"])], (elems = [createElement(CustomPropertiesPropertyList, {
                Currency: props.CustomerConfiguration.Currency,
                CustomProperties: externalPerson_1.CustomProperties,
            })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
        },
        ReceiverId: props.ReceiverId,
        ReceiverType: props.ToolBox.Receiver.ReceiverType,
        TriggerRequest: props.TriggerRerender,
        UserData: props.UserData,
    });
}

export function RoomDetails(props) {
    const t = useTranslation()[0];
    return createElement(ReceiverDetails, {
        AccountSettings: props.AccountSettings,
        FetchReceiver: Async_valueOrRaise(Async_fetchWithDecoder(addPrefix(concat("/api/receivers/rooms/", unwrapUserId(new UserId_3(props.ReceiverId)), ..."/details")), "", new HttpMethod(0, []), "application/json", (response) => singleton_2.Delay(() => {
            let resp;
            const matchValue = response.content;
            switch (matchValue.tag) {
                case 0: {
                    throw new Exception("not implemented - text response");
                    break;
                }
                case 1: {
                    throw new Exception("not implemented - blob response");
                    break;
                }
                case 3: {
                    resp = matchValue.fields[0];
                    break;
                }
                default:
                    resp = (new Uint8Array(matchValue.fields[0]));
            }
            return singleton_2.Return(Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(resp), Requests_RoomDto_$reflection()));
        }))),
        FormState: props.FormState,
        ImageUrl: (room) => room.ImageUrl,
        OnDeleteImage: props.OnDeleteImage,
        OnUploadImage: props.OnUploadImage,
        ReceiverActions: (_arg) => createElement(ToolboxDetailActions, {
            Actions: createElement(ReceiverDetailButtons, {
                AccountSettings: props.AccountSettings,
                CustomerConfiguration: props.CustomerConfiguration,
                Dispatch: props.Dispatch,
                HasInspectionDocuments: props.ToolBox.HasInspectionDocuments,
                IsArchived: props.ToolBox.Receiver.IsArchived,
                ReceiverType: props.ToolBox.Receiver.ReceiverType,
                UserData: props.UserData,
            }),
            Customer: props.Customer,
            Dispatch: props.Dispatch,
            HistoryRows: props.HistoryRows,
            Receiver: props.ToolBox.Receiver,
            Toolbox: props.ToolBox,
            UserData: props.UserData,
        }),
        ReceiverDetails: (room_1) => {
            let elems_1, elems;
            let locationName;
            const matchValue_1 = room_1.LocationId;
            if (matchValue_1 == null) {
                locationName = "";
            }
            else {
                const locationId = matchValue_1;
                locationName = defaultArg(map_1((location_1) => location_1.Name, tryFind((location) => equals(location.Id, locationId), props.Locations)), "");
            }
            return reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems_1 = [createElement(PropertyList, {
                Properties: toList(delay(() => append(singleton({
                    Label: t("general.name"),
                    TestId: "receiver-name",
                    Value: room_1.Name,
                }), delay(() => append(isFeatureEnabled(new Feature(17, [])) ? (props.AccountSettings.BusinessUnitsEnabled ? singleton({
                    Label: t("business_units.business_unit"),
                    TestId: "receiver-business-unit-name",
                    Value: defaultArg(room_1.BusinessUnitName, ""),
                }) : empty()) : empty(), delay(() => append(isFeatureEnabled(new Feature(15, [])) ? singleton({
                    Label: t("general.email"),
                    TestId: "receiver-email",
                    Value: room_1.Email,
                }) : empty(), delay(() => append(isFeatureEnabled(new Feature(6, [])) ? singleton({
                    Label: t("user.is_archived"),
                    TestId: "receiver-is-archived",
                    Value: room_1.IsArchived ? t("general.yes") : t("general.no"),
                }) : empty(), delay(() => append(singleton({
                    Label: t("room.number"),
                    TestId: "receiver-room-number",
                    Value: room_1.Number,
                }), delay(() => singleton({
                    Label: t("room.location"),
                    TestId: "receiver-location",
                    Value: locationName,
                }))))))))))))),
            }), reactElement("div", createObj(ofArray([["className", join(" ", ["border-t", "border-divider"])], (elems = [createElement(CustomPropertiesPropertyList, {
                Currency: props.CustomerConfiguration.Currency,
                CustomProperties: room_1.CustomProperties,
            })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
        },
        ReceiverId: props.ReceiverId,
        ReceiverType: props.ToolBox.Receiver.ReceiverType,
        TriggerRequest: props.TriggerRerender,
        UserData: props.UserData,
    });
}

export function SubcontractorDetails(props) {
    const t = useTranslation()[0];
    return createElement(ReceiverDetails, {
        AccountSettings: props.AccountSettings,
        FetchReceiver: Async_valueOrRaise(Async_fetchWithDecoder(addPrefix(concat("/api/receivers/subcontractors/", unwrapUserId(new UserId_3(props.ReceiverId)), ..."/details")), "", new HttpMethod(0, []), "application/json", (response) => singleton_2.Delay(() => {
            let resp;
            const matchValue = response.content;
            switch (matchValue.tag) {
                case 0: {
                    throw new Exception("not implemented - text response");
                    break;
                }
                case 1: {
                    throw new Exception("not implemented - blob response");
                    break;
                }
                case 3: {
                    resp = matchValue.fields[0];
                    break;
                }
                default:
                    resp = (new Uint8Array(matchValue.fields[0]));
            }
            return singleton_2.Return(Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(resp), Requests_SubcontractorDto_$reflection()));
        }))),
        FormState: props.FormState,
        ImageUrl: (subcontractor) => subcontractor.ImageUrl,
        OnDeleteImage: props.OnDeleteImage,
        OnUploadImage: props.OnUploadImage,
        ReceiverActions: (_arg) => createElement(ToolboxDetailActions, {
            Actions: createElement(ReceiverDetailButtons, {
                AccountSettings: props.AccountSettings,
                CustomerConfiguration: props.CustomerConfiguration,
                Dispatch: props.Dispatch,
                HasInspectionDocuments: props.ToolBox.HasInspectionDocuments,
                IsArchived: props.ToolBox.Receiver.IsArchived,
                ReceiverType: props.ToolBox.Receiver.ReceiverType,
                UserData: props.UserData,
            }),
            Customer: props.Customer,
            Dispatch: props.Dispatch,
            HistoryRows: props.HistoryRows,
            Receiver: props.ToolBox.Receiver,
            Toolbox: props.ToolBox,
            UserData: props.UserData,
        }),
        ReceiverDetails: (subcontractor_1) => {
            let elems_1, elems;
            return reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems_1 = [createElement(PropertyList, {
                Properties: toList(delay(() => append(singleton({
                    Label: t("general.name"),
                    TestId: "receiver-name",
                    Value: subcontractor_1.Name,
                }), delay(() => append(isFeatureEnabled(new Feature(17, [])) ? (props.AccountSettings.BusinessUnitsEnabled ? singleton({
                    Label: t("business_units.business_unit"),
                    TestId: "receiver-business-unit-name",
                    Value: defaultArg(subcontractor_1.BusinessUnitName, ""),
                }) : empty()) : empty(), delay(() => append(isFeatureEnabled(new Feature(15, [])) ? singleton({
                    Label: t("general.email"),
                    TestId: "receiver-email",
                    Value: subcontractor_1.Email,
                }) : empty(), delay(() => (isFeatureEnabled(new Feature(6, [])) ? singleton({
                    Label: t("user.is_archived"),
                    TestId: "receiver-is-archived",
                    Value: subcontractor_1.IsArchived ? t("general.yes") : t("general.no"),
                }) : empty()))))))))),
            }), reactElement("div", createObj(ofArray([["className", join(" ", ["border-t", "border-divider"])], (elems = [createElement(CustomPropertiesPropertyList, {
                Currency: props.CustomerConfiguration.Currency,
                CustomProperties: subcontractor_1.CustomProperties,
            })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
        },
        ReceiverId: props.ReceiverId,
        ReceiverType: props.ToolBox.Receiver.ReceiverType,
        TriggerRequest: props.TriggerRerender,
        UserData: props.UserData,
    });
}

export function ProjectDetails(props) {
    const t = useTranslation()[0];
    return createElement(ReceiverDetails, {
        AccountSettings: props.AccountSettings,
        FetchReceiver: Async_valueOrRaise(Async_fetchWithDecoder(addPrefix(concat("/api/receivers/projects/", unwrapUserId(new UserId_3(props.ReceiverId)), ..."/details")), "", new HttpMethod(0, []), "application/json", (response) => singleton_2.Delay(() => {
            let resp;
            const matchValue = response.content;
            switch (matchValue.tag) {
                case 0: {
                    throw new Exception("not implemented - text response");
                    break;
                }
                case 1: {
                    throw new Exception("not implemented - blob response");
                    break;
                }
                case 3: {
                    resp = matchValue.fields[0];
                    break;
                }
                default:
                    resp = (new Uint8Array(matchValue.fields[0]));
            }
            return singleton_2.Return(Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(resp), Requests_ProjectDto_$reflection()));
        }))),
        FormState: props.FormState,
        ImageUrl: (project) => project.ImageUrl,
        OnDeleteImage: props.OnDeleteImage,
        OnUploadImage: props.OnUploadImage,
        ReceiverActions: (_arg) => createElement(ToolboxDetailActions, {
            Actions: createElement(ReceiverDetailButtons, {
                AccountSettings: props.AccountSettings,
                CustomerConfiguration: props.CustomerConfiguration,
                Dispatch: props.Dispatch,
                HasInspectionDocuments: props.ToolBox.HasInspectionDocuments,
                IsArchived: props.ToolBox.Receiver.IsArchived,
                ReceiverType: props.ToolBox.Receiver.ReceiverType,
                UserData: props.UserData,
            }),
            Customer: props.Customer,
            Dispatch: props.Dispatch,
            HistoryRows: props.HistoryRows,
            Receiver: props.ToolBox.Receiver,
            Toolbox: props.ToolBox,
            UserData: props.UserData,
        }),
        ReceiverDetails: (project_1) => {
            let elems_1, elems;
            return reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems_1 = [createElement(PropertyList, {
                Properties: toList(delay(() => append(singleton({
                    Label: t("general.name"),
                    TestId: "receiver-name",
                    Value: project_1.Name,
                }), delay(() => append(isFeatureEnabled(new Feature(17, [])) ? (props.AccountSettings.BusinessUnitsEnabled ? singleton({
                    Label: t("business_units.business_unit"),
                    TestId: "receiver-business-unit-name",
                    Value: defaultArg(project_1.BusinessUnitName, ""),
                }) : empty()) : empty(), delay(() => append(isFeatureEnabled(new Feature(15, [])) ? singleton({
                    Label: t("general.email"),
                    TestId: "receiver-email",
                    Value: project_1.Email,
                }) : empty(), delay(() => append(singleton({
                    Label: t("general.description"),
                    TestId: "receiver-description",
                    Value: project_1.Description,
                }), delay(() => (isFeatureEnabled(new Feature(6, [])) ? singleton({
                    Label: t("user.is_archived"),
                    TestId: "receiver-is-archived",
                    Value: project_1.IsArchived ? t("general.yes") : t("general.no"),
                }) : empty()))))))))))),
            }), reactElement("div", createObj(ofArray([["className", join(" ", ["border-t", "border-divider"])], (elems = [createElement(CustomPropertiesPropertyList, {
                Currency: props.CustomerConfiguration.Currency,
                CustomProperties: project_1.CustomProperties,
            })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
        },
        ReceiverId: props.ReceiverId,
        ReceiverType: props.ToolBox.Receiver.ReceiverType,
        TriggerRequest: props.TriggerRerender,
        UserData: props.UserData,
    });
}

export function ConstructionSiteDetails(props) {
    const t = useTranslation()[0];
    return createElement(ReceiverDetails, {
        AccountSettings: props.AccountSettings,
        FetchReceiver: Async_valueOrRaise(Async_fetchWithDecoder(addPrefix(concat("/api/receivers/construction-sites/", unwrapUserId(new UserId_3(props.ReceiverId)), ..."/details")), "", new HttpMethod(0, []), "application/json", (response) => singleton_2.Delay(() => {
            let resp;
            const matchValue = response.content;
            switch (matchValue.tag) {
                case 0: {
                    throw new Exception("not implemented - text response");
                    break;
                }
                case 1: {
                    throw new Exception("not implemented - blob response");
                    break;
                }
                case 3: {
                    resp = matchValue.fields[0];
                    break;
                }
                default:
                    resp = (new Uint8Array(matchValue.fields[0]));
            }
            return singleton_2.Return(Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(resp), Requests_ConstructionSiteDto_$reflection()));
        }))),
        FormState: props.FormState,
        ImageUrl: (constructionSite) => constructionSite.ImageUrl,
        OnDeleteImage: props.OnDeleteImage,
        OnUploadImage: props.OnUploadImage,
        ReceiverActions: (_arg) => createElement(ToolboxDetailActions, {
            Actions: createElement(ReceiverDetailButtons, {
                AccountSettings: props.AccountSettings,
                CustomerConfiguration: props.CustomerConfiguration,
                Dispatch: props.Dispatch,
                HasInspectionDocuments: props.ToolBox.HasInspectionDocuments,
                IsArchived: props.ToolBox.Receiver.IsArchived,
                ReceiverType: props.ToolBox.Receiver.ReceiverType,
                UserData: props.UserData,
            }),
            Customer: props.Customer,
            Dispatch: props.Dispatch,
            HistoryRows: props.HistoryRows,
            Receiver: props.ToolBox.Receiver,
            Toolbox: props.ToolBox,
            UserData: props.UserData,
        }),
        ReceiverDetails: (constructionSite_1) => {
            let elems_1, elems;
            return reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems_1 = [createElement(PropertyList, {
                Properties: toList(delay(() => append(singleton({
                    Label: t("general.name"),
                    TestId: "receiver-name",
                    Value: constructionSite_1.Name,
                }), delay(() => append(isFeatureEnabled(new Feature(17, [])) ? (props.AccountSettings.BusinessUnitsEnabled ? singleton({
                    Label: t("business_units.business_unit"),
                    TestId: "receiver-business-unit-name",
                    Value: defaultArg(constructionSite_1.BusinessUnitName, ""),
                }) : empty()) : empty(), delay(() => append(isFeatureEnabled(new Feature(15, [])) ? singleton({
                    Label: t("general.email"),
                    TestId: "receiver-email",
                    Value: constructionSite_1.Email,
                }) : empty(), delay(() => append(singleton({
                    Label: t("general.description"),
                    TestId: "receiver-description",
                    Value: constructionSite_1.Description,
                }), delay(() => (isFeatureEnabled(new Feature(6, [])) ? singleton({
                    Label: t("user.is_archived"),
                    TestId: "receiver-is-archived",
                    Value: constructionSite_1.IsArchived ? t("general.yes") : t("general.no"),
                }) : empty()))))))))))),
            }), reactElement("div", createObj(ofArray([["className", join(" ", ["border-t", "border-divider"])], (elems = [createElement(CustomPropertiesPropertyList, {
                Currency: props.CustomerConfiguration.Currency,
                CustomProperties: constructionSite_1.CustomProperties,
            })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
        },
        ReceiverId: props.ReceiverId,
        ReceiverType: props.ToolBox.Receiver.ReceiverType,
        TriggerRequest: props.TriggerRerender,
        UserData: props.UserData,
    });
}

export function SchoolClassDetails(props) {
    const t = useTranslation()[0];
    return createElement(ReceiverDetails, {
        AccountSettings: props.AccountSettings,
        FetchReceiver: Async_valueOrRaise(Async_fetchWithDecoder(addPrefix(concat("/api/receivers/school-classes/", unwrapUserId(new UserId_3(props.ReceiverId)), ..."/details")), "", new HttpMethod(0, []), "application/json", (response) => singleton_2.Delay(() => {
            let resp;
            const matchValue = response.content;
            switch (matchValue.tag) {
                case 0: {
                    throw new Exception("not implemented - text response");
                    break;
                }
                case 1: {
                    throw new Exception("not implemented - blob response");
                    break;
                }
                case 3: {
                    resp = matchValue.fields[0];
                    break;
                }
                default:
                    resp = (new Uint8Array(matchValue.fields[0]));
            }
            return singleton_2.Return(Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(resp), Requests_SchoolClassDto_$reflection()));
        }))),
        FormState: props.FormState,
        ImageUrl: (schoolClass) => schoolClass.ImageUrl,
        OnDeleteImage: props.OnDeleteImage,
        OnUploadImage: props.OnUploadImage,
        ReceiverActions: (_arg) => createElement(ToolboxDetailActions, {
            Actions: createElement(ReceiverDetailButtons, {
                AccountSettings: props.AccountSettings,
                CustomerConfiguration: props.CustomerConfiguration,
                Dispatch: props.Dispatch,
                HasInspectionDocuments: props.ToolBox.HasInspectionDocuments,
                IsArchived: props.ToolBox.Receiver.IsArchived,
                ReceiverType: props.ToolBox.Receiver.ReceiverType,
                UserData: props.UserData,
            }),
            Customer: props.Customer,
            Dispatch: props.Dispatch,
            HistoryRows: props.HistoryRows,
            Receiver: props.ToolBox.Receiver,
            Toolbox: props.ToolBox,
            UserData: props.UserData,
        }),
        ReceiverDetails: (schoolClass_1) => {
            let elems_1, elems;
            return reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems_1 = [createElement(PropertyList, {
                Properties: toList(delay(() => append(singleton({
                    Label: t("general.name"),
                    TestId: "receiver-name",
                    Value: schoolClass_1.Name,
                }), delay(() => append(isFeatureEnabled(new Feature(17, [])) ? (props.AccountSettings.BusinessUnitsEnabled ? singleton({
                    Label: t("business_units.business_unit"),
                    TestId: "receiver-business-unit-name",
                    Value: defaultArg(schoolClass_1.BusinessUnitName, ""),
                }) : empty()) : empty(), delay(() => append(isFeatureEnabled(new Feature(15, [])) ? singleton({
                    Label: t("general.email"),
                    TestId: "receiver-email",
                    Value: schoolClass_1.Email,
                }) : empty(), delay(() => append(singleton({
                    Label: t("general.description"),
                    TestId: "receiver-description",
                    Value: schoolClass_1.Description,
                }), delay(() => (isFeatureEnabled(new Feature(6, [])) ? singleton({
                    Label: t("user.is_archived"),
                    TestId: "receiver-is-archived",
                    Value: schoolClass_1.IsArchived ? t("general.yes") : t("general.no"),
                }) : empty()))))))))))),
            }), reactElement("div", createObj(ofArray([["className", join(" ", ["border-t", "border-divider"])], (elems = [createElement(CustomPropertiesPropertyList, {
                Currency: props.CustomerConfiguration.Currency,
                CustomProperties: schoolClass_1.CustomProperties,
            })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
        },
        ReceiverId: props.ReceiverId,
        ReceiverType: props.ToolBox.Receiver.ReceiverType,
        TriggerRequest: props.TriggerRerender,
        UserData: props.UserData,
    });
}

export function StudentDetails(props) {
    const t = useTranslation()[0];
    return createElement(ReceiverDetails, {
        AccountSettings: props.AccountSettings,
        FetchReceiver: Async_valueOrRaise(Async_fetchWithDecoder(addPrefix(concat("/api/receivers/students/", unwrapUserId(new UserId_3(props.ReceiverId)), ..."/details")), "", new HttpMethod(0, []), "application/json", (response) => singleton_2.Delay(() => {
            let resp;
            const matchValue = response.content;
            switch (matchValue.tag) {
                case 0: {
                    throw new Exception("not implemented - text response");
                    break;
                }
                case 1: {
                    throw new Exception("not implemented - blob response");
                    break;
                }
                case 3: {
                    resp = matchValue.fields[0];
                    break;
                }
                default:
                    resp = (new Uint8Array(matchValue.fields[0]));
            }
            return singleton_2.Return(Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(resp), Requests_StudentDto_$reflection()));
        }))),
        FormState: props.FormState,
        ImageUrl: (student) => student.ImageUrl,
        OnDeleteImage: props.OnDeleteImage,
        OnUploadImage: props.OnUploadImage,
        ReceiverActions: (_arg) => createElement(ToolboxDetailActions, {
            Actions: createElement(ReceiverDetailButtons, {
                AccountSettings: props.AccountSettings,
                CustomerConfiguration: props.CustomerConfiguration,
                Dispatch: props.Dispatch,
                HasInspectionDocuments: props.ToolBox.HasInspectionDocuments,
                IsArchived: props.ToolBox.Receiver.IsArchived,
                ReceiverType: props.ToolBox.Receiver.ReceiverType,
                UserData: props.UserData,
            }),
            Customer: props.Customer,
            Dispatch: props.Dispatch,
            HistoryRows: props.HistoryRows,
            Receiver: props.ToolBox.Receiver,
            Toolbox: props.ToolBox,
            UserData: props.UserData,
        }),
        ReceiverDetails: (student_1) => {
            let elems_1, elems;
            return reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems_1 = [createElement(PropertyList, {
                Properties: toList(delay(() => append(singleton({
                    Label: t("general.name"),
                    TestId: "receiver-name",
                    Value: student_1.Name,
                }), delay(() => append(isFeatureEnabled(new Feature(17, [])) ? (props.AccountSettings.BusinessUnitsEnabled ? singleton({
                    Label: t("business_units.business_unit"),
                    TestId: "receiver-business-unit-name",
                    Value: defaultArg(student_1.BusinessUnitName, ""),
                }) : empty()) : empty(), delay(() => append(singleton({
                    Label: t("student.student_number"),
                    TestId: "receiver-student-number",
                    Value: student_1.StudentNumber,
                }), delay(() => append(isFeatureEnabled(new Feature(15, [])) ? singleton({
                    Label: t("general.email"),
                    TestId: "receiver-email",
                    Value: student_1.Email,
                }) : empty(), delay(() => (isFeatureEnabled(new Feature(6, [])) ? singleton({
                    Label: t("user.is_archived"),
                    TestId: "receiver-is-archived",
                    Value: student_1.IsArchived ? t("general.yes") : t("general.no"),
                }) : empty()))))))))))),
            }), reactElement("div", createObj(ofArray([["className", join(" ", ["border-t", "border-divider"])], (elems = [createElement(CustomPropertiesPropertyList, {
                Currency: props.CustomerConfiguration.Currency,
                CustomProperties: student_1.CustomProperties,
            })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
        },
        ReceiverId: props.ReceiverId,
        ReceiverType: props.ToolBox.Receiver.ReceiverType,
        TriggerRequest: props.TriggerRerender,
        UserData: props.UserData,
    });
}

export function VehicleDetails(props) {
    const t = useTranslation()[0];
    return createElement(ReceiverDetails, {
        AccountSettings: props.AccountSettings,
        FetchReceiver: Async_valueOrRaise(Async_fetchWithDecoder(addPrefix(concat("/api/receivers/vehicles/", unwrapUserId(new UserId_3(props.ReceiverId)), ..."/details")), "", new HttpMethod(0, []), "application/json", (response) => singleton_2.Delay(() => {
            let resp;
            const matchValue = response.content;
            switch (matchValue.tag) {
                case 0: {
                    throw new Exception("not implemented - text response");
                    break;
                }
                case 1: {
                    throw new Exception("not implemented - blob response");
                    break;
                }
                case 3: {
                    resp = matchValue.fields[0];
                    break;
                }
                default:
                    resp = (new Uint8Array(matchValue.fields[0]));
            }
            return singleton_2.Return(Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(resp), Requests_VehicleDto_$reflection()));
        }))),
        FormState: props.FormState,
        ImageUrl: (student) => student.ImageUrl,
        OnDeleteImage: props.OnDeleteImage,
        OnUploadImage: props.OnUploadImage,
        ReceiverActions: (_arg) => createElement(ToolboxDetailActions, {
            Actions: createElement(ReceiverDetailButtons, {
                AccountSettings: props.AccountSettings,
                CustomerConfiguration: props.CustomerConfiguration,
                Dispatch: props.Dispatch,
                HasInspectionDocuments: props.ToolBox.HasInspectionDocuments,
                IsArchived: props.ToolBox.Receiver.IsArchived,
                ReceiverType: props.ToolBox.Receiver.ReceiverType,
                UserData: props.UserData,
            }),
            Customer: props.Customer,
            Dispatch: props.Dispatch,
            HistoryRows: props.HistoryRows,
            Receiver: props.ToolBox.Receiver,
            Toolbox: props.ToolBox,
            UserData: props.UserData,
        }),
        ReceiverDetails: (vehicle) => {
            let elems_1, elems;
            return reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems_1 = [createElement(PropertyList, {
                Properties: toList(delay(() => append(singleton({
                    Label: t("general.name"),
                    TestId: "receiver-name",
                    Value: vehicle.Name,
                }), delay(() => append(isFeatureEnabled(new Feature(17, [])) ? (props.AccountSettings.BusinessUnitsEnabled ? singleton({
                    Label: t("business_units.business_unit"),
                    TestId: "receiver-business-unit-name",
                    Value: defaultArg(vehicle.BusinessUnitName, ""),
                }) : empty()) : empty(), delay(() => append(singleton({
                    Label: t("vehicle.numberplate"),
                    TestId: "receiver-numberplate",
                    Value: vehicle.NumberPlate,
                }), delay(() => append(singleton({
                    Label: t("vehicle.manufacturer"),
                    TestId: "receiver-manufacturer",
                    Value: vehicle.Manufacturer,
                }), delay(() => append(singleton({
                    Label: t("vehicle.model"),
                    TestId: "receiver-model",
                    Value: vehicle.Model,
                }), delay(() => append(singleton({
                    Label: t("general.location"),
                    TestId: "receiver-location",
                    Value: defaultArg(map_1((_arg_1) => _arg_1.Name, tryFind((location) => equals(location.Id, vehicle.LocationId), props.Locations)), ""),
                }), delay(() => append(isFeatureEnabled(new Feature(15, [])) ? singleton({
                    Label: t("general.email"),
                    TestId: "receiver-email",
                    Value: vehicle.Email,
                }) : empty(), delay(() => (isFeatureEnabled(new Feature(6, [])) ? singleton({
                    Label: t("user.is_archived"),
                    TestId: "receiver-is-archived",
                    Value: vehicle.IsArchived ? t("general.yes") : t("general.no"),
                }) : empty()))))))))))))))))),
            }), reactElement("div", createObj(ofArray([["className", join(" ", ["border-t", "border-divider"])], (elems = [createElement(CustomPropertiesPropertyList, {
                Currency: props.CustomerConfiguration.Currency,
                CustomProperties: vehicle.CustomProperties,
            })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
        },
        ReceiverId: props.ReceiverId,
        ReceiverType: props.ToolBox.Receiver.ReceiverType,
        TriggerRequest: props.TriggerRerender,
        UserData: props.UserData,
    });
}

